import { ReactComponent as PlusIcon } from '@elementary/common-ui/assets/20x20/plus-black.svg';
import { ReactComponent as TrashIcon } from '@elementary/common-ui/assets/trash.svg';
import {
  Button,
  Flex,
  FlexColumn,
  IconButton,
  formFieldRequiredLabel as requiredLabel,
  TextField,
} from '@elementary/common-ui/components';
import FormControls from '@elementary/common-ui/components/FormControls';
import { Typography } from '@mui/material';
import { UseFormReturn, useFieldArray } from 'react-hook-form';
import { MicrosoftTeamsForm } from 'shared/types';
import { isValidUrl } from 'shared/utils/validators';

function WebhooksArray({
  control,
  register,
  formState: { errors },
}: UseFormReturn<MicrosoftTeamsForm, any, undefined>) {
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'webhooks',
  });

  return (
    <FlexColumn sx={{ gap: 1 }}>
      {fields.map((webhook, index) => (
        <Flex gap={1} alignItems="center" key={webhook.id}>
          <FormControls.InputWrapper>
            <TextField
              fullWidth
              placeholder="webhook name"
              {...register(`webhooks.${index}.name`, {
                required: requiredLabel,
              })}
              size="large"
            />
            <FormControls.ErrorMessage paddingLeft={0.5}>
              {errors.webhooks?.[index]?.name?.message}
            </FormControls.ErrorMessage>
          </FormControls.InputWrapper>

          <FormControls.InputWrapper sx={{ flex: 1 }}>
            <TextField
              fullWidth
              placeholder="webhook url"
              {...register(`webhooks.${index}.url`, {
                required: requiredLabel,
                validate: (value) =>
                  isValidUrl(value) ? true : 'This is not a valid url',
              })}
              size="large"
            />
            <FormControls.ErrorMessage paddingLeft={0.5}>
              {errors.webhooks?.[index]?.url?.message}
            </FormControls.ErrorMessage>
          </FormControls.InputWrapper>

          <IconButton>
            <TrashIcon
              onClick={() => {
                remove(index);
              }}
            />
          </IconButton>
        </Flex>
      ))}

      <Button
        startIcon={<PlusIcon />}
        onClick={() => append({ name: '', url: '' })}
        sx={{ width: '140px' }}
        variant="text"
        color="secondary"
      >
        <Typography fontSize={14}> Add webhook</Typography>
      </Button>
    </FlexColumn>
  );
}

export default WebhooksArray;
